export default __webpack_public_path__ + "media/images/mail-30fb752583742d0966a72c408e7456ff.png";